module.exports = __webpack_public_path__ + "img/top_icon_interview.23e7a32c.svg";